import React, { FC } from 'react';
import styles from './separator.module.scss';

export const BigLineSeparator: FC = () => <div className={styles.big} />;

export const SmallLineSeparator: FC = () => <div className={styles.small} />;
